import React from 'react'
import axios from '../../utils/axios'
import { withRouter } from 'react-router-dom'
import successIcon from '../../images/success-icon.svg'
import { saveAs } from 'file-saver';


import './verify-success.style.scss'

const VerifySuccessComponent = (props) => {

  const formattedDate = new Date(props.dateSigned).toLocaleDateString('hr-Hr', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  })
  
  const handleDownloadDocument = async () => {
    try {
      saveAs(props.downloadLink, props.fileName);
    } catch (error) {      
      throw error
    }
  }

  const handleValidateDocument = async () => {
    try {
      const response = await axios.get(props.downloadLink , { responseType: 'arraybuffer' })
      const base64Document = Buffer.from(response.data, 'binary').toString('base64')
      props.validateDocument({base64Document, fileName: 'validation-report.pdf'})
      props.history.push('/validacija')
    } catch (error) {      
      throw error
    }
     
  }
  
  return (
    <div>
      <img className="success-icon" src={successIcon} alt=""/>
      <h1 className="success-title">Izvornik dokumenta moguće je dohvatiti</h1>
      <p className="success-info">
        Prema evidenciji potpisnog servisa dokument je potpisan {formattedDate} i moguće ga je dohvatiti.
      </p>
     
      <button className="link-button" onClick={handleDownloadDocument}>Dohvati izvornik</button>
      <button className="link-button" onClick={handleValidateDocument}>Validiraj izvornik</button>
      
    </div>
  )
}

export default withRouter(VerifySuccessComponent)